import produce from 'immer';
// import { FilterKey, PageSearchParams, SearchParamsType } from '@/app/types/searchparams';
import { FilterKey, FilterOptionKeys, PageSearchParams, SearchParams, SORT_KEYS } from '@mybestbrands/types';

export const initialSearchParams: SearchParams = {
  currentPath: '',
  q: '',
  page: 1,
  sort: SORT_KEYS?.POPULARITY,
  pageTags: '',
  filters: {
    sizes: [],
    colors: [],
    brands: [],
    retailers: [],
    categories: [],
    materials: [],
    sale: false,
    price: [],
    genders: [],
    patterns: [],
    coupon: false,
    hottest_sale: false,
  },
};

export function safelyParseJSON(filters: string | undefined | null) {
  try {
    return JSON.parse(filters || '{}');
  } catch (e) {
    return {};
  }
}

export const buildSearchParamsFromUrl = (slug: string, pageSearchParams: PageSearchParams, gender: string) => {
  return produce(initialSearchParams, (draft) => {
    try {
      const filtersParsed = safelyParseJSON(pageSearchParams?.filters);

      Object.entries(draft.filters).forEach(([key]) => {
        const filterKey = key as FilterKey;

        if (filterKey && filterKey in filtersParsed && filtersParsed[filterKey]) {
          draft.filters[filterKey] = filtersParsed[filterKey];
        }
      });

      //set gender from cookie if it's not set via filter params
      if (!draft.filters.genders?.length && gender) {
        draft.filters.genders = [gender];
      }

      draft.page = pageSearchParams.page ?? initialSearchParams.page;
      draft.sort = pageSearchParams.sort ?? initialSearchParams.sort;
      draft.pageTags = pageSearchParams.pageTags ?? initialSearchParams.pageTags;
      draft.q = pageSearchParams.q ?? initialSearchParams.q;
      if (pageSearchParams.seasortorder) {
        draft.seasortorder = pageSearchParams.seasortorder;
      }
      if (pageSearchParams.product) {
        draft.product = pageSearchParams.product;
      }
      if ('pageType' in pageSearchParams) {
        draft.currentPath = `/${pageSearchParams.pageType}/${slug}/`;
      } else {
        draft.currentPath = `/${slug}/`;
      }
      if (pageSearchParams.pageVariant) {
        draft.pageVariant = pageSearchParams.pageVariant;
      }
      if (pageSearchParams.pdp_overlay) {
        draft.pdp_overlay = pageSearchParams.pdp_overlay;
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('e', e);
      return initialSearchParams;
    }
  });
};

export const getPathWithoutSlashes = (path: string) => path.replace(/\/$/, '').replace(/^\//, '');

export const isAnyFilterSelected = (searchParams: SearchParams | undefined, excludedFilters: FilterOptionKeys[]) =>
  Object.entries(searchParams?.filters ?? {}).some(([key, value]) => {
    if (excludedFilters.includes(key as FilterOptionKeys)) return false;
    if (key === FilterOptionKeys.SALE && value) return true;
    if (key === FilterOptionKeys.COUPON && value) return true;
    if (key === FilterOptionKeys.HOTTEST_SALE && value) return true;
    if (Array.isArray(value)) return value.length > 0;
    return false;
  });

export const selectedFilterCount = (searchParams: SearchParams | undefined, excludedFilters: FilterOptionKeys[] = []) =>
  Object.entries(searchParams?.filters ?? {}).reduce((acc, [key, value]) => {
    if (excludedFilters.includes(key as FilterOptionKeys)) return acc;

    if (
      (key === FilterOptionKeys.SALE && value) ||
      (key === FilterOptionKeys.COUPON && value) ||
      (key === FilterOptionKeys.HOTTEST_SALE && value) ||
      (key === FilterOptionKeys.PRICE && ((value as string[]) ?? []).length > 0)
    )
      return acc + 1;
    if (Array.isArray(value)) return acc + value.length;
    return acc;
  }, 0);
